import React from "react";
import styled from "styled-components";

const Divider = styled.div`
  width: 94%;
  height: 1px;
  background: linear-gradient(
    to right,
    transparent,
    var(--text-secondary),
    transparent
  );
  margin-bottom: 2rem;
  align-self: center;
`;

const SectionDivider = () => {
  return <Divider />;
};

export default SectionDivider;
